import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const createCategoryHierarchy = payload => {
  const categories = payload.reduce(
    (parents, category) => ({
      ...parents,
      [category.categoryName]: [
        ...(parents[category.categoryName] || []),
        {
          id: category.id,
          name: category.subCategoryName,
          reviewRequiredDocuments: category.reviewRequiredDocuments,
        },
      ],
    }),
    {}
  )

  return Object.keys(categories)
    .sort()
    .map(key => ({
      name: key,
      children: categories[key],
    }))
}

const fetchBizCategories = createAxiosThunk(
  'channelAdd/fetchBizCategories',
  () => api.channel.getBizCategories()
)

fetchBizCategories.reducers = builder => {
  builder.addCase(fetchBizCategories.pending, state => {
    state.isCategoryLoading = true
  })

  builder.addCase(fetchBizCategories.fulfilled, (state, { payload }) => {
    state.bizCategories = createCategoryHierarchy(payload)
    state.isCategoryLoading = false
  })

  builder.addCase(fetchBizCategories.rejected, (state, { payload }) => {
    state.apiError = payload
    state.isCategoryLoading = false
  })
}

export default fetchBizCategories
